export const MIN_SCROLL_HEADER = 38;
